import React from 'react';
import { Stack } from '../stack';
import { Box } from '../box';
import { Button } from '../button';
import { Typography } from '../typography';
import { useTheme } from '../../hooks/useTheme';
import { MinusIcon, PlusIcon } from '../../icons';
// import { MOBILE_BREAKPOINT_THRESHOLD } from '../../theme';
import { CounterProps } from './model';
export type { CounterProps } from './model';

export const Counter: React.FC<CounterProps> = ({ min = 0, max = Number.MAX_SAFE_INTEGER, label, value, onChange, subjectLabel }) => {
  const theme = useTheme();

  const handleDec = () => {
    onChange(Math.max(value - 1, min));
  };

  const handleInc = () => {
    onChange(Math.min(value + 1, max));
  };

  const isDisabledDec = value <= min;
  const isDisabledInc = value >= max;

  return (
    <Box
      sx={{
        backgroundColor: 'gray ultra light',
        borderRadius: '12px',
        border: `1px solid ${theme.palette['gray light']}`,
        p: 1.5,
        width: 1,
        // maxWidth: { xs: 'none', [MOBILE_BREAKPOINT_THRESHOLD]: 380 },
        display: 'flex',
        justifyContent: 'center',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ display: 'inline-flex', flexDirection: 'column' }}>
        {label ? (
          <Typography component="div" sx={{ mb: 1.5, textAlign: 'center' }} variant="button">
            {label}
          </Typography>
        ) : null}
        <Stack direction="row">
          <Button disabled={isDisabledDec} onClick={handleDec} sx={{ flex: '1 1 0px' }} variant="text">
            <MinusIcon color={isDisabledDec ? 'gray' : undefined} fontSize="1.5rem" />
          </Button>
          <Stack direction="column" sx={{ alignItems: 'center', mx: 1.5, minWidth: 40 }}>
            <Typography variant="h1">{value}</Typography>
            {subjectLabel ? (
              <Typography sx={{ color: 'gray' }} variant="caption bold">
                {subjectLabel}
              </Typography>
            ) : null}
          </Stack>
          <Button disabled={isDisabledInc} onClick={handleInc} sx={{ flex: '1 1 0px' }} variant="text">
            <PlusIcon color={isDisabledInc ? 'gray' : undefined} fontSize="1.5rem" />
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};
